// Identificadores canónicos de los tabs del DashboardReports. Estos strings son
// el contrato compartido entre: (a) el `TAB_REGISTRY` de DashboardReports.vue
// (qué componente montar + fallback), (b) el `ROW_TO_TAB` de ResultadosTab.vue
// (navegación cross-tab desde el P&L) y (c) el `data-theme="X"` de cada tab
// hijo. La navegación VISIBLE de los tabs vive en el sidebar
// (`components/layout/navConfig.js`). Centralizar los ids acá evita typos
// silenciosos entre esos lugares.
export const TAB_IDS = Object.freeze({
    RESULTADOS: "resultados",
    VENTAS: "ventas",
    COSTOS: "costos",
    GASTOS: "gastos",
    RENTABILIDAD: "rentabilidad",
    NO_OPER: "no_oper",
    ACTIVOS: "activos",
    KPIS: "kpis",
    PROYECCIONES: "proyecciones",
});
